import textHtml from "../Text/text-html";
import buttonHtml from "../Button/button-html";
import imageHtml from "../Image/image-html";
import inputFieldHtml from "../FormCommonField/input-field-html";
import formTermsHtml from "../FormTerms/form-terms-html";
import formTextHtml from "../FormText/form-text-html";
import formTextareaHtml from "../FormTextarea/form-textarea-html";
import formPhoneHtml from "../FormPhone/form-phone-html";
import formOptionHtml from "../FormOption/form-option-html";
import formRadioGridHtml from "../FormRadioGrid/form-radio-grid-html";
import formMultiOptionHtml from "../FormMultiOption/form-multi-option-html";
import formNumberHtml from "../FormNumber/form-number-html";
import formDropdownHtml from "../FormDropdown/form-dropdown-html";
import formSubmitButtonHtml from "../FormSubmitButton/form-submit-button-html";
import formRatingHtml from "../FormRating/form-rating-html";
import dividerHtml from "../Divider/divider-html";
import htmlHtml from "../Html/html-html";
import countdownHtml from "../Countdown/countdown-html";
import couponHtml from "../Coupon/coupon-html";
import formThankyouHtml from "../FormThankyou/form-thankyou-html";

// content show in preview and real page
const HTML_CNT_MAPPING = {
  text: textHtml,
  heading: textHtml,
  image: imageHtml,
  divider: dividerHtml,
  coupon: couponHtml,
  button: buttonHtml,
  html: htmlHtml,
  countdown: countdownHtml,
  "form-text": formTextHtml,
  "form-email": inputFieldHtml,
  "form-date": inputFieldHtml,
  "form-number": formNumberHtml,
  "form-url": inputFieldHtml,
  "form-textarea": formTextareaHtml,
  "form-option": formOptionHtml,
  "form-multi-option": formMultiOptionHtml,
  // custom form input:
  "form-dropdown": formDropdownHtml,
  "form-phone": formPhoneHtml,
  "form-rating": formRatingHtml,
  "form-radio-grid": formRadioGridHtml,
  "form-submit-button": formSubmitButtonHtml,
  "form-terms": formTermsHtml,
  "form-thankyou": formThankyouHtml,
};

export default (node, root, preview = false) => {
  let colStyle = "";
  if (node.parent.data.gutter) {
    const pd = node.parent.data.gutter / 2;
    colStyle = `padding-left: ${pd}px;padding-right: ${pd}px;`;
  }
  return `
      <div class="${node.className}" style="${colStyle}">
        ${node.children
          .map((node) => {
            const ContentComponet = HTML_CNT_MAPPING[node.type];
            return ContentComponet
              ? ContentComponet({
                  data: node.data,
                  type: node.type,
                  id: node.id,
                  root,
                  preview,
                })
              : '<div data-unsupport="Not Support Component:  ' + node.type +'" ></div>';
          }).join("")}
      </div>
    `;
};
